import { useEffect, useState } from 'react';
import { CardPayment } from './CardPayment';
import { UserAgreement } from './UserAgreement';

const PaymentButton = ({ label, value, onClick, activeTab, tabIndex }) => {
	return (
		<button
			type="button"
			onClick={onClick}
			className={`tab-tagger ${activeTab === value ? 'active' : ''}`}
			tabIndex={tabIndex}
		>
			<span className="tab-tagger-icon"></span>
			{label}
		</button>
	);
};

export function BillingDetails({
	billingInfo,
	setBillingInfo,
	hidePaymentOptions,
	setRequiredAddress,
	...props
}) {
	const [activeTab, setActiveTab] = useState(
		billingInfo?.edd_gateway || 'stripe'
	);

	// useEffect(() => {
	// 	let paymentMethod = hidePaymentOptions ? 'manual' : activeTab;

	// 	console.log('PaymentMethod', paymentMethod, hidePaymentOptions)

	// 	// if( hidePaymentOptions === true && activeTab === paymentMethod && paymentMethod === 'manual' ) {
	// 	// 	paymentMethod = 'stripe';
	// 	// }

	// 	// setBillingInfo(prev => ({
	// 	// 	...prev,
	// 	// 	edd_gateway: paymentMethod,
	// 	// 	payment_mode: paymentMethod,
	// 	// }));

	// 	// if (paymentMethod === 'paypalexpress') {
	// 	// 	setRequiredAddress(false);
	// 	// } else {
	// 	// 	setRequiredAddress(true);
	// 	// }

	// 	setActiveTab(paymentMethod);
	// }, [activeTab, hidePaymentOptions, setBillingInfo, props.cartData]);

	useEffect(() => {
		let paymentMethod = hidePaymentOptions
			? 'manual'
			: billingInfo?.edd_gateway;
		setActiveTab(paymentMethod);
	}, [hidePaymentOptions, billingInfo]);

	useEffect(() => {
		setBillingInfo(prev => ({
			...prev,
			edd_gateway: activeTab,
			payment_mode: activeTab,
		}));

		if (activeTab === 'paypalexpress') {
			setRequiredAddress(false);
		} else {
			setRequiredAddress(true);
		}
	}, [activeTab]);

	return (
		<>
			<div className="wp-checkout-BillingDetails-wrapper">
				<h2 className="wp-checkout-font-xl wp-checkout-section-header">
					Billing Details
				</h2>
				{!hidePaymentOptions && (
					<div className="wp-checkout-BillingDetails-tabs">
						<PaymentButton
							onClick={() => setActiveTab('stripe')}
							value="stripe"
							activeTab={billingInfo?.edd_gateway}
							label="Pay With Card"
							tabIndex={5}
						/>
						<PaymentButton
							onClick={() => setActiveTab('paypalexpress')}
							value="paypalexpress"
							activeTab={billingInfo?.edd_gateway}
							label="Pay With PayPal"
							tabIndex={6}
						/>
					</div>
				)}

				<div className="wp-checkout-BillingDetails-tabs-content">
					{(activeTab === 'stripe' || activeTab === 'manual') && (
						<div>
							<CardPayment
								setBillingInfo={setBillingInfo}
								{...props}
							/>
						</div>
					)}
					<UserAgreement
						setBillingInfo={setBillingInfo}
						billingInfo={billingInfo}
						billingInfoErrors={props.billingInfoErrors}
						checkValidation={props.checkValidation}
					/>
				</div>
			</div>
		</>
	);
}
